import { createContext, useContext } from "react";
import { noop } from "@common/helpers/function";

export interface NewVersionAvailableContextValue {
    notifyNewVersionAvailable(): void;
    isNoticeVisible: boolean;
    refresh(): void;
}

export const newVersionAvailableContext =
    createContext<NewVersionAvailableContextValue>({
        notifyNewVersionAvailable: noop,
        isNoticeVisible: false,
        refresh: noop,
    });

export function useNewVersionAvailable() {
    return useContext(newVersionAvailableContext);
}
